import { createEnvAccessor } from '@web-store-platforms/utils';

const isNonEmptyString = (value: string | undefined): value is string =>
    value !== undefined && value.trim() !== '';

// Next.js replaces process.env.NEXT_PUBLIC_* at build time via static analysis,
// so dynamic access like process.env[key] won't resolve. We must reference each
// variable explicitly for the inlining to work on the client side.
export const getEnvVariable = createEnvAccessor({
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_STORE_DOMAIN: process.env.NEXT_PUBLIC_STORE_DOMAIN,
    NEXT_PUBLIC_CORALOGIX_PUBLIC_KEY: process.env.NEXT_PUBLIC_CORALOGIX_PUBLIC_KEY,
    NEXT_PUBLIC_STORE_VERSION: process.env.NEXT_PUBLIC_STORE_VERSION,
    NEXT_PUBLIC_SHARED_UI_VERSION: process.env.NEXT_PUBLIC_SHARED_UI_VERSION,
    NEXT_PUBLIC_CHECKOUT_SDK_VERSION: process.env.NEXT_PUBLIC_CHECKOUT_SDK_VERSION,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    REACT_APP_ENV: process.env.REACT_APP_ENV,
    REACT_APP_SHARED_UI_VERSION: process.env.REACT_APP_SHARED_UI_VERSION,
    REACT_APP_CHECKOUT_SDK_VERSION: process.env.REACT_APP_CHECKOUT_SDK_VERSION,
});

/** Like getEnvVariable, but treats blank values as unset (build scripts often write `KEY=`). */
export const getNonEmptyEnvVariable = (key: string): string | undefined => {
    const value = getEnvVariable(key);
    return isNonEmptyString(value) ? value : undefined;
};
